export default "__VITE_ASSET__266afce5__"